/**
 * SORA 15-minute basket hold (client-side checkout-priority UX).
 * Starts after add-to-cart. On expiry POSTs /cart/clear.js and empties the bag.
 * No customer-facing hold box. Do not rewrite the site announcement.
 */
(function () {
  var STORAGE_PREFIX = "soraBasketReserve:";
  var ATTR_UNTIL = "basket_reserved_until";
  var ATTR_HOLD = "basket_hold";

  function honestNote() {
    var mins = Number(config().minutes) || 15;
    return (
      "Basket held in this browser for " +
      mins +
      " minutes. Checkout place, not warehouse stock"
    );
  }

  function expiredNote() {
    return "Hold ended. Bag cleared (browser hold, not a warehouse lock)";
  }

  function routesRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  }

  function config() {
    var el = document.getElementById("sora-basket-reserve-config");
    var fallback = {
      enabled: true,
      minutes: 15,
      itemCount: 0,
      cartToken: "",
      cartUrl: "/cart",
      pageType: "",
    };
    if (!el) return fallback;
    try {
      return Object.assign(fallback, JSON.parse(el.textContent || "{}"));
    } catch (e) {
      return fallback;
    }
  }

  function holdMs() {
    var m = Number(config().minutes) || 15;
    return Math.max(1, Math.min(60, m)) * 60 * 1000;
  }

  function storageKey(token) {
    return STORAGE_PREFIX + (token || "anon");
  }

  function readState(token) {
    try {
      var raw = localStorage.getItem(storageKey(token));
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeState(token, state) {
    try {
      localStorage.setItem(storageKey(token), JSON.stringify(state));
    } catch (e) {}
  }

  function clearState(token) {
    try {
      localStorage.removeItem(storageKey(token));
    } catch (e) {}
  }

  function hideVisualMounts() {
    document
      .querySelectorAll("[data-sora-basket-reserve], .sora-reserve, .cart-drawer__sora-reserve")
      .forEach(function (el) {
        el.hidden = true;
        el.setAttribute("hidden", "");
        el.setAttribute("aria-hidden", "true");
        el.style.display = "none";
      });
  }

  function syncCartAttributes(untilIso, expired) {
    if (!window.fetch) return;
    var attributes = {};
    attributes[ATTR_UNTIL] = expired ? "" : untilIso || "";
    attributes[ATTR_HOLD] = expired ? expiredNote() : honestNote();
    fetch(routesRoot() + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ attributes: attributes }),
    }).catch(function () {});
  }

  function writeConfigPatch(patch) {
    var el = document.getElementById("sora-basket-reserve-config");
    if (!el) return;
    try {
      var data = Object.assign(config(), patch);
      el.textContent = JSON.stringify(data);
    } catch (e) {}
  }

  function startOrRefresh(token) {
    var until = Date.now() + holdMs();
    writeState(token, { until: until, startedAt: Date.now() });
    syncCartAttributes(new Date(until).toISOString(), false);
    render();
  }

  var expireInFlight = false;

  function jsonPost(path, body) {
    return fetch(routesRoot() + path, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(body || {}),
    });
  }

  function clearShopifyCart() {
    if (!window.fetch) {
      return Promise.resolve({ item_count: 0, items: [] });
    }
    return jsonPost("cart/clear.js", {})
      .then(function (res) {
        if (res && res.ok) return res.json();
        return fetch(routesRoot() + "cart.js", { credentials: "same-origin" })
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .then(function (cart) {
            if (!cart || !cart.items || !cart.items.length) {
              return cart || { item_count: 0, items: [] };
            }
            var chain = Promise.resolve();
            cart.items.forEach(function (item) {
              chain = chain.then(function () {
                return jsonPost("cart/change.js", { id: item.key, quantity: 0 });
              });
            });
            return chain.then(function () {
              return fetch(routesRoot() + "cart.js", { credentials: "same-origin" }).then(function (r2) {
                return r2.ok ? r2.json() : { item_count: 0, items: [] };
              });
            });
          });
      })
      .catch(function () {
        return { item_count: 0, items: [] };
      });
  }

  function paintEmptyHeaderBadge() {
    document.querySelectorAll(".cart-badge").forEach(function (el) {
      el.remove();
    });
    try {
      sessionStorage.setItem(
        "cart-count",
        JSON.stringify({ value: "0", timestamp: Date.now() })
      );
    } catch (e) {}
  }

  function paintEmptyBag() {
    var bag = document.getElementById("bag-root");
    if (!bag) return;
    var countEl = bag.querySelector(".bag__count");
    if (countEl) countEl.remove();
    var form = document.getElementById("bag-form") || bag.querySelector(".bag__layout");
    if (form) form.remove();
    if (!bag.querySelector(".bag__empty")) {
      var empty = document.createElement("div");
      empty.className = "bag__empty";
      empty.innerHTML =
        "<p>Your bag is empty.</p><a class=\"bag__cta\" href=\"" +
        routesRoot() +
        "#chapters\">Continue shopping</a>";
      bag.appendChild(empty);
    }
  }

  function replaceSectionHtml(sectionId, html) {
    if (!html || !sectionId) return;
    var current = document.getElementById("shopify-section-" + sectionId);
    if (!current) return;
    var tmp = document.createElement("div");
    tmp.innerHTML = html.trim();
    var next =
      tmp.querySelector("#shopify-section-" + sectionId) || tmp.firstElementChild;
    if (next) current.replaceWith(next);
  }

  function refreshDrawerSection() {
    if (!window.fetch) return Promise.resolve();
    var sectionId = "cart-drawer-section";
    if (!document.getElementById("shopify-section-" + sectionId) && !document.getElementById("cart-drawer")) {
      return Promise.resolve();
    }
    return fetch(routesRoot() + "?section_id=" + encodeURIComponent(sectionId), {
      credentials: "same-origin",
    })
      .then(function (r) {
        return r.ok ? r.text() : "";
      })
      .then(function (html) {
        if (html) replaceSectionHtml(sectionId, html);
      })
      .catch(function () {});
  }

  function applyClearedCartUi(cart) {
    var count = cart && typeof cart.item_count === "number" ? cart.item_count : 0;
    window.__soraCartItemCount = count;
    writeConfigPatch({
      itemCount: count,
      cartToken: (cart && cart.token) || config().cartToken,
    });
    paintEmptyHeaderBadge();
    paintEmptyBag();
    refreshDrawerSection();
  }

  function itemCount() {
    if (typeof window.__soraCartItemCount === "number") return window.__soraCartItemCount;
    return Number(config().itemCount) || 0;
  }

  function render() {
    hideVisualMounts();
  }

  function markExpiredIfNeeded() {
    var token = config().cartToken || "";
    var state = readState(token);
    if (!state || !state.until || Date.now() < state.until) return;
    if (state.cartCleared || expireInFlight) {
      if (!state.expiredNotified) {
        state.expiredNotified = true;
        writeState(token, state);
        syncCartAttributes("", true);
      }
      return;
    }
    expireInFlight = true;
    state.expiredNotified = true;
    writeState(token, state);
    syncCartAttributes("", true);
    clearShopifyCart()
      .then(function (cart) {
        var next = readState(token) || state;
        next.expiredNotified = true;
        next.cartCleared = true;
        writeState(token, next);
        applyClearedCartUi(cart);
        render();
      })
      .catch(function () {
        applyClearedCartUi({ item_count: 0, items: [] });
        render();
      })
      .then(function () {
        expireInFlight = false;
      });
  }

  function onCartJs(refreshHold) {
    if (!window.fetch) {
      render();
      return;
    }
    fetch(routesRoot() + "cart.js", { credentials: "same-origin" })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (!cart) {
          render();
          return;
        }
        window.__soraCartItemCount = cart.item_count;
        writeConfigPatch({
          itemCount: cart.item_count,
          cartToken: cart.token || config().cartToken,
        });
        var token = cart.token || config().cartToken || "";
        if (cart.item_count < 1) {
          var existing = readState(token);
          if (existing && existing.until && Date.now() >= existing.until) {
            render();
            return;
          }
          clearState(token);
          render();
          return;
        }
        if (refreshHold) {
          startOrRefresh(token);
          return;
        }
        var st = readState(token);
        if (!st || !st.until) startOrRefresh(token);
        else render();
      })
      .catch(function () {
        render();
      });
  }

  function interceptAdds() {
    if (!window.fetch || window.__soraBasketFetchWrapped) return;
    window.__soraBasketFetchWrapped = true;
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = "";
      if (typeof input === "string") url = input;
      else if (input && input.url) url = input.url;
      var method = (init && init.method) || (input && input.method) || "GET";
      var isAdd =
        /\/cart\/add(\.js)?/i.test(url) && String(method).toUpperCase() !== "GET";
      return nativeFetch.apply(this, arguments).then(function (res) {
        if (isAdd && res && res.ok) {
          try {
            onCartJs(true);
          } catch (e) {}
        }
        return res;
      });
    };
  }

  function bindForms() {
    document.addEventListener(
      "submit",
      function (event) {
        var form = event.target;
        if (!form || !form.matches) return;
        var isProduct =
          form.matches('form[action*="/cart/add"]') ||
          form.id === "sora-product-form" ||
          form.getAttribute("data-type") === "add-to-cart-form";
        if (!isProduct) return;
        /* Hold starts only after a successful add, not on submit. */
      },
      true
    );
  }

  function bindRefreshButtons() {
    document.addEventListener("click", function (event) {
      var btn = event.target && event.target.closest && event.target.closest("[data-reserve-refresh]");
      if (!btn) return;
      event.preventDefault();
      onCartJs(true);
    });
  }

  function bindDrawer() {
    document.addEventListener("theme-drawer:open", function (event) {
      var target = event && event.target;
      if (target && target.id && target.id !== "cart-drawer") return;
      if (!document.getElementById("cart-drawer")) return;
      onCartJs(false);
    });
  }

  function ensureHold() {
    var token = config().cartToken || "";
    var st = readState(token);
    if (!st || !st.until) {
      startOrRefresh(token);
      return;
    }
    render();
    if (st.until <= Date.now()) markExpiredIfNeeded();
  }

  function boot() {
    var c = config();
    if (c.enabled === false) return;
    interceptAdds();
    bindForms();
    bindRefreshButtons();
    bindDrawer();
    hideVisualMounts();
    if (itemCount() > 0) {
      ensureHold();
      onCartJs(false);
    } else {
      var st = readState(c.cartToken || "");
      if (st && st.until && Date.now() >= st.until) {
        markExpiredIfNeeded();
      }
      render();
    }
    setInterval(function () {
      markExpiredIfNeeded();
      render();
    }, 1000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
